<template>
  <figure>
    <img
      :alt="props.label" 
      :src="props.src" 
      :height="`${LIST_ITEM_HEIGHT}px`" 
      loading="lazy"
    />
    <figcaption>{{ props.label }}</figcaption>
  </figure>
</template>

<script setup>
  import { Props } from './props';
  import { LIST_ITEM_HEIGHT } from '../../config/config';
  //---------------------------------------------
  const props = defineProps(Props());
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>